export const NO_BREAK_SPACE = '\u00a0'
